import './_DataFeedForm.scss';
import { useEffect, useState } from 'react';
import { Card, Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { feedConstants } from '../../../../../constants/DataFeed';
import { TDataFeedFormValues, ITooltip, KeyType } from '../types/IDataFeedForm';
import { GET_DATA_FEED_FORM_CHANGE } from '../../../../../store/actionTypes';
import { useDispatch } from 'react-redux';
import { Prompt } from 'react-router-dom';
import { ErrorMessage, Field, useFormikContext } from 'formik';
import ValidationError from './ValidationError';
import moment from 'moment';
// keeping props:any for now, will be covered with validation of FormikProps
const DataFeedForm = (props: any) => {
  const {
    enabled,
    disabled,
    endPointUrlText,
    aestrix,
    endPointUrlTooltipMessage,
    endPointUsernameText,
    endPointUsenameTooltipMessage,
    usernamePlaceholder,
    endPointPasswordText,
    endPointPasswordTooltipMessage,
    promptMsg,
  } = feedConstants;
  const { values, errors, dirty, touched, handleChange } =
    useFormikContext<TDataFeedFormValues>();
  const [toggle, setToggle] = useState(values.isDataFeedEnabled);
  const renderTooltip = (props: ITooltip) => (
    <Tooltip className="tooltip" id={`button-tooltip-${props.id}`} {...props}>
      {props.message}
    </Tooltip>
  );
  const dispatch = useDispatch();
  useEffect(() => {
    const data = {
      isDatafeedFormChange: dirty,
      editfeedPage: '/editdatafeed/:id',
    };
    dispatch({
      type: GET_DATA_FEED_FORM_CHANGE,
      data,
    });
    const beforeUnloadListener = (e: any) => {
      if (dirty) {
        e.preventDefault();
        e.returnValue = true;
      }
    };
    window.addEventListener('beforeunload', beforeUnloadListener);
    return () =>
      window.removeEventListener('beforeunload', beforeUnloadListener);
  }, [dirty]);

  const datafeedStatus = toggle ? 'enabled' : 'disabled';

  const [showPassword, setShowPassword] = useState(false);
  const [showUsername, setShowUsername] = useState(false);

  return (
    <Card className="form-card-container" data-testid="form-card-container">
      <Prompt when={dirty && !props.isUpdate} message={promptMsg} />
      <Row className="mb-4 justify-content-start">
        <Col md={6} className="feedname">
          <Card.Text className="form-card-text">
            {props.feed.feedTypeName}
            {/* <i
              id="feed-info-icon"
              data-testid="feed-info-icon"
              className="fa fa-info-circle"
              aria-hidden="true"
              aria-label="Feed Information Icon"
              onClick={() => props.handleModal(props.feed)}
              tabIndex={0}
              onKeyPress={async (e) => {
                if (e.key === KeyType.Enter) {
                  props.handleModal(props.feed);
                }
              }}
            ></i> */}
          </Card.Text>
        </Col>
        {props.actionType == 'edit' && (
          <Col md={6} className="p-0 datafeed-toggle">
            <Form.Group
              className="enabled-data-feed"
              as={Col}
              md="12"
              controlId="isDataFeedEnabled"
            >
              <Form.Label
                className={`form-input-label ${datafeedStatus}`}
                as={Col}
                md="4"
              >
                {toggle ? enabled : disabled}
              </Form.Label>
              <Form.Check
                type="switch"
                name="isDataFeedEnabled"
                onChange={handleChange}
                onInput={() => setToggle(!toggle)}
                onKeyPress={async (e) => {
                  if (e.key === KeyType.Enter) {
                    setToggle(!toggle);
                  }
                }}
                checked={toggle}
                value={toggle ? 1 : 2}
              />
            </Form.Group>
          </Col>
        )}
      </Row>
      <Form.Group className="mb-4" as={Col} md="12" controlId="endpointUrl">
        <Form.Label className="form-input-label">
          {`${endPointUrlText}${aestrix}`}
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip({
              message: endPointUrlTooltipMessage,
              id: 'endPointUrl',
            })}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </OverlayTrigger>
        </Form.Label>
        <Field
          id="endpointUrl"
          name="endpointUrl"
          className={
            errors.endpointUrl && touched.endpointUrl
              ? 'form-input-control form-control is-invalid'
              : 'form-input-control form-control'
          }
          placeholder={endPointUrlText}
        />
        <ErrorMessage component={ValidationError} name="endpointUrl" />
      </Form.Group>
      <Form.Group
        className="mb-4"
        as={Col}
        md="12"
        controlId="endpointUsername"
      >
        <Form.Label className="form-input-label">
          {`${endPointUsernameText}${aestrix}`}

          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip({
              message: endPointUsenameTooltipMessage,
              id: 'endpointUsername',
            })}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </OverlayTrigger>
        </Form.Label>
        <div className="passsword-field">
          <Field
            id="endpointUsername"
            name="endpointUsername"
            type={showUsername ? 'text' : 'password'}
            className={
              errors.endpointUsername && touched.endpointUsername
                ? 'form-input-control form-control is-invalid'
                : 'form-input-control form-control'
            }
            placeholder={usernamePlaceholder}
          />
          {!showUsername ? (
            <i
              className="fa fa-eye-slash toggle-password-icon"
              onClick={() => setShowUsername(true)}
            ></i>
          ) : (
            <i
              className="fa fa-eye toggle-password-icon"
              onClick={() => setShowUsername(false)}
            ></i>
          )}
        </div>
        <ErrorMessage component={ValidationError} name="endpointUsername" />
      </Form.Group>

      <Form.Group
        className="mb-4"
        as={Col}
        md="12"
        controlId="endpointPassword"
      >
        <Form.Label className="form-input-label">
          {`${endPointPasswordText}${aestrix}`}

          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip({
              message: endPointPasswordTooltipMessage,
              id: 'endpointPassword',
            })}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </OverlayTrigger>
        </Form.Label>
        <div className="passsword-field">
          <Field
            id="endpointPassword"
            name="endpointPassword"
            type={showPassword ? 'text' : 'password'}
            className={
              errors.endpointPassword && touched.endpointPassword
                ? 'form-input-control form-control is-invalid'
                : 'form-input-control form-control'
            }
            placeholder="Type your password"
          />
          {!showPassword ? (
            <i
              className="fa fa-eye-slash toggle-password-icon"
              onClick={() => setShowPassword(true)}
            ></i>
          ) : (
            <i
              className="fa fa-eye toggle-password-icon"
              onClick={() => setShowPassword(false)}
            ></i>
          )}
        </div>
        <ErrorMessage component={ValidationError} name="endpointPassword" />
        {props.actionType == 'edit' && (
          <ul className="create-update-date">
            <li>{`Created on: ${moment(values.createdDate).format(
              'HH:mm',
            )}`}</li>
            <li>{`Last Updated: ${moment(values.lastUpdatedDate).format(
              'HH:mm',
            )}`}</li>
          </ul>
        )}
      </Form.Group>
    </Card>
  );
};
export default DataFeedForm;
